import { HttpApiRequestOptions, HttpRequestData } from '@core/http-types';

export abstract class IntegrationsHttpRequestData extends HttpRequestData {}

export interface IntegrationHttpApiRequestOptions extends HttpApiRequestOptions {
  context?: string;
}

export interface VideoInterview {
  joinUrl: string;
}
